export default () => ({
  show: false,
  loading: false,
  checkout: false,
  isPage: false,
  count: 0,
  updateCart() {
    this.loading = true;
    let url = Shopify.routes.root + "?view=cart";

    if (this.isPage) {
      url = Shopify.routes.root + "?view=cart-page";
    }

    // send fetch reqeust to update cart
    fetch(url)
      .then((response) => response.text())
      .then((cartData) => {
        var cartContentEl = this.$refs.cart_content;
        cartContentEl.innerHTML = cartData;
        Array.from(cartContentEl.querySelectorAll("script")).forEach(
          (oldScriptEl) => {
            const newScriptEl = document.createElement("script");

            Array.from(oldScriptEl.attributes).forEach((attr) => {
              newScriptEl.setAttribute(attr.name, attr.value);
            });

            const scriptText = document.createTextNode(oldScriptEl.innerHTML);
            newScriptEl.appendChild(scriptText);

            oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
          }
        );

        // This code is use to parse json object. for cart count
        var el = document.createElement("div");
        el.innerHTML = cartData;
        var cartCount = JSON.parse(
          el.querySelector("[data-options]").innerHTML
        ).item_count;

        this.count = cartCount;
        this.$dispatch("cart-count", cartCount);
        this.loading = false;

        // Reload Nosto cart with skipEvents flag after cart content is updated
        if (typeof Nosto !== "undefined" && window.Nosto) {
          window.Nosto.reloadCartWithFlags({ skipEvents: true });
        }
      });
  },
  open() {
    this.show = true;
    Grebify.noScroll(true);
  },
  hide() {
    this.show = false;
    Grebify.noScroll(false);
  },
  updateQuantity(line, qty, increase) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: qty, line: line }),
    })
      .then((response) => response.json())
      .then((data) => {
        const items = data.items;
        const item = Array.isArray(items) ? items[line - 1] : null;
        const variant = Tracking.transformVariant(item);

        if (variant && Tracking) {
          Tracking.updateQuantity(variant, increase);
        }
        // fire javascript event on window
        window.dispatchEvent(new Event("cart-updated"));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
});
